define('helperContent-componentObject',['knockout-mapping'], function(mapping) {
    'use strict';

    function getComponents(scope) {
        return (scope.components ? scope.components : [])
    }

    function getComponentsByKindFromArray(components, kind) {
        var comps = [];

        if(components.length > 0) {
            components.forEach(function (component) {
                if(component.kind === kind) {
                    comps.push(component);
                }
            });
        }
        return comps;
    }

    function getComponentsByKind(scope, kind) {
        var comps = [],
            components = [];

        if(scope.components() !== undefined){
            components = mapping.toJS(scope.components());
        }

        if(components.length > 0) {
            comps = getComponentsByKindFromArray(components, kind);
        }
        return comps;
    }

    function getComponentsOfPageByKind(page, kind) {
        var comps = [],
            components = [];

        if (page.contentEntity !== undefined && page.contentEntity.components !== undefined) {
            components = page.contentEntity.components;

            if (components.length > 0) {
                components.forEach(function (component) {
                    if (component.kind === kind) {
                        comps.push(component);
                    }
                });
            }
        }
        return comps;
    }

    function getComponentParamValuesByName(scope, name) {
        var params  = [],
            i       = null,
            j       = null,
            content = null,
            components = [];

        if(scope.components() !== undefined){
            components = mapping.toJS(getComponents(scope));
        }

        if ( components && components.length ) {
            i = components.length;

            while(i--) {
                content = components[i].content;
                if(content.index){
                    j = content.index.length;
                    while(j--) {
                        var paramName = content.index[j];
                        if ( paramName === name ) {
                            params.push(content[paramName]);
                        }
                    }
                }
            }
        }

        return params;
    }

    // function getComponentParams(component, param) {
    //     var params  = [],
    //         content = null;

    //     if(component && component.content){
    //         content = component.content;
    //         if(content.images){
    //             params = _.pluck(content.images, "content");
    //         }
    //     }
    //     return params;
    // }

    // function getCurrentComponentParamValuesByName(scope, name) {
    //     // MR: Not tested properly
    //     var params  = [],
    //         i       = null,
    //         j       = null,
    //         content = null,
    //         components = [];

    //     if(scope.components() !== undefined){
    //         components = scope.components();
    //     }

    //     if ( components && components.length ) {
    //         i = components.length;

    //         while(i--) {
    //             content = components[i].content;
    //             if(content.index){
    //                 j = content.index.length;
    //                 while(j--) {
    //                     var paramName = content.index[j];
    //                     if ( paramName === name && content[paramName] ) {
    //                         params.push(content[paramName]);
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     return params;
    // }

    // function getComponentParamValuesOfPageByName(page, name) {
    //     // MR: Not tested!!
    //     var values  = [],
    //         j       = null,
    //         content = null,
    //         components = [];

    //     if(page.contentEntity.components !== undefined){
    //         components = page.contentEntity.components;

    //         if (components.length > 0) {
    //             components.forEach(function (component) {

    //                 content = components[i].content;
    //                 if(content.index){
    //                     j = content.index.length;
    //                     while(j--) {
    //                         var paramName = content.index[j];
    //                         if ( paramName === name && content[paramName] ) {
    //                             values.push(content[paramName]);
    //                         }
    //                     }
    //                 }
    //             });
    //         }
    //     }

    //     return values;
    // };

    // function getComponentsByParamValue(components, name, id) {
    //     var comps = [],
    //         componentContents = _.map(components, 'content');

    //     if(componentContents && componentContents.length > 0){
    //         var filter = {};
    //         filter[name] = id;
    //         comps = _.filter(componentContents, filter);
    //     }

    //     return comps;
    // };

    return {
        getComponents:getComponents,
        getComponentsByKindFromArray:getComponentsByKindFromArray,
        getComponentsByKind:getComponentsByKind,
        getComponentsOfPageByKind:getComponentsOfPageByKind,
        getComponentParamValuesByName:getComponentParamValuesByName,
        // getComponentParams:getComponentParams,
        // getCurrentComponentParamValuesByName:getCurrentComponentParamValuesByName,
        // getComponentParamValuesOfPageByName:getComponentParamValuesOfPageByName,
        // getComponentsByParamValue:getComponentsByParamValue
    } ;

});


